<template>
  <div class="title">
    <h1 v-html="title"></h1>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'title'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  background-image: url(../assets/sprite.svg#xsarus-icon);
  background-size: 4rem 4rem;
  background-repeat: no-repeat;
  background-position: left center;
  color: rgba(255,255,255,.7);
  font-size: 4rem;
  font-weight: 400;
  padding-left: 6rem;
}
</style>
